export const getUserMessages = state => {
  return state.userMessages;
};
export const getUserTabMessages = state => {
  return state.userTabMessages;
};

export const getChatMessages = state => (userId, limiter) => {
  let user = state.userMessages.find(user => user.id === userId);
  if (user?.messages > 0) {
    let messages = user.messages.slice().reverse();
    console.log(messages);
    return messages.slice(0, limiter).reverse();
  }
  return [];
};

export const getLastMsgFromChat = state => userId => {
  let user = state.userMessages.find(user => user.id === userId);
  let lastMsg = user.messages[user.messages.length - 1];
  return lastMsg;
};

export const getModeratorMessages = state => {
  return state.moderatorMessagesAsMember.filter(chat => chat.isOpen);
};

export const getOpenChats = state => {
  return state.openChats;
};

export const getNewMsgsCounter = state => {
  return state.newMessagesCounter;
};

export const getStateWindowChat = state => {
  return state.windowChatState;
};

export const getWindowChatMsgs = state => {
  return state.windowChatMsgs;
};

export const getSystemNotifications = state => {
  return state.notifications;
};

export const getUserMessagesCount = state => {
  return state.userMessagesCount;
};
